import { useEffect } from "react";
import AppGallery from "@/components/AppGallery";
import { appItems } from "@/data/appItems";
import RootLayout from "@/layout/RootLayout";
import { trackEvent } from "@/services/analyticsService";

export default function Home() {
  useEffect(() => {
    trackEvent("home_page_view");
  }, []);

  return (
    <RootLayout title="AI Playground">
      <AppGallery appItems={appItems} />
    </RootLayout>
  );
}
